<template>
  <div>
    <!--     <VideoCallRoom
      v-if="!inLogin && videoCallData"
      :videoCallData="videoCallData"
      :userData="userData"
      :atencionID="atencionID"
    /> -->
    <VideoCallRoom
      v-if="videoCallData && userData"
      :videoCallData="videoCallData"
      :userData="userData"
      :atencionID="videoCallData.attention_id"
    />
  </div>
</template>

<script>
import VideoCallRoom from "../videocall/VideoCallRoom.vue";
import { getReservationById } from "@/helpers/api/horas_medicas";

export default {
  components: { VideoCallRoom },
  data() {
    return {
      userData: null,
      videoCallData: null,
/*        videoCallData: {
        id: 12,
        socket_url: "https://vcsocket.anubys.cl:8443/",
        socket_room: "LKfHLIdP8iT9j9ARG97D",
        attention_id: 23,
        deleted_at: null,
        created_at: "2024-07-03T20:52:33.000000Z",
        updated_at: "2024-07-03T20:52:33.000000Z",
        user_id: 7,
        profile: {
        id: 7,
        name: "Esteban Abarca",
        address: "Avenida Siempre Viva 8989",
        phone: 987878787,
        birthday: null,
        user_id: 7,
        role_id: 2,
        company_id: null,
        commune_id: 13,
        deleted_at: null,
        created_at: "2024-06-27T16:11:18.000000Z",
        updated_at: "2024-06-27T16:11:18.000000Z",
      }, 
      }, */
    };
  },
  mounted() {
        this.userData = this.$store.state.userData;
        const reserv_id = this.$route.query.reservation_id;
        getReservationById({id: +reserv_id}).then(res => {
          this.videoCallData = res.data.reservation_attention.video_call
          console.log(res.data.reservation_attention);
        })

/*     this.userData = {
      id: 7,
      email: "eabarca@naturalphone.cl",
      rut: "19037568-4",
      email_verified_at: "2024-06-27T16:11:48.000000Z",
      deleted_at: null,
      created_at: "2024-06-27T16:11:18.000000Z",
      updated_at: "2024-07-03T17:00:04.000000Z",
      profile: {
        id: 7,
        name: "Esteban Abarca",
        address: "Avenida Siempre Viva 8989",
        phone: 987878787,
        birthday: null,
        user_id: 7,
        role_id: 2,
        company_id: null,
        commune_id: 13,
        deleted_at: null,
        created_at: "2024-06-27T16:11:18.000000Z",
        updated_at: "2024-06-27T16:11:18.000000Z",
      },
    }; */
  },
};
</script>

<style lang="scss" scoped></style>
